// 🔒
import TrainerCard from "./TrainerCard";
import { trainers } from "../data/trainers";

export default function TrainersSection() {
  return (
    <section className="section trainers" id="trainers">
      <div className="container">
        <div className="section-heading trainers-section__heading">
          <p className="eyebrow">OUR TRAINERS</p>
          <h2>Meet the coaches behind the results</h2>
          <p className="section-copy">
            Your app is powered by professional trainers who combine strength,
            conditioning, movement quality, and long-term coaching experience.
          </p>
        </div>

        <div className="trainers-grid">
          {trainers.map((trainer) => (
            <TrainerCard key={trainer.id} trainer={trainer} />
          ))}
        </div>
      </div>
    </section>
  );
}
// 🔒